import { guidEmpty } from "utils/guid-empty";

export class FinalizadoraOrdemModel {
  constructor(
    public ordem: number = 0,
    public id: string = guidEmpty()
  ) { }
}